import { useSuspenseQuery } from '@tanstack/react-query'

import { GetProfissoesService } from '@/features/clientes/services/get-profissoes.service'
import { profissaoClienteKeys } from '@/features/clientes/utils'

export const useSuspenseProfissoes = () => {
  return useSuspenseQuery({
    queryKey: profissaoClienteKeys.lista(),
    queryFn: async () => new GetProfissoesService().execute().then((res) => res.data),
  })
}
